/*
 * VH-209 — the compact ingredient line under a cooking step.
 *
 * One component for every output. The PDF is rasterized from the printable
 * DOM and the print view is the same DOM under a print stylesheet, so screen,
 * print and PDF all render this — which is the only way they cannot drift.
 *
 * `isTotal` is not decoration: the system holds one amount per ingredient, so
 * an ingredient named in two steps shows its FULL amount in both. Saying
 * "total" is what stops that reading as "200 g, twice".
 */

import { useTranslation } from 'react-i18next'

export default function StepIngredientLine({ items, className = '' }) {
  const { t } = useTranslation()

  if (!items || !items.length) return null

  return (
    <span
      className={`block text-sm text-gray-600 mt-1 ${className}`.trim()}
      data-testid="step-ingredient-line"
    >
      {items.map((item, index) => {
        const amount = [item.amount, item.unit]
          .filter((part) => part !== null && part !== undefined && part !== '')
          .join(' ')
        const measure = item.isTotal
          ? t('recipes.detail.amountTotal', { amount })
          : amount
        return (
          <span key={item.id} data-testid={`step-ingredient-${item.id}`}>
            {index > 0 ? ' · ' : ''}
            {item.name}
            {measure ? ` ${measure}` : ''}
            {item.notes ? ` (${item.notes})` : ''}
          </span>
        )
      })}
    </span>
  )
}
